import { UsuariosListSearchComponent } from './UsuariosListSearchComponent'
import { UsuariosListToolbar } from './UsuariosListToolbar'

export const UsuariosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <UsuariosListSearchComponent actions={<UsuariosListToolbar />} />
    </div>
  )
}
